export default {
  props: {
    select: Function,
    itemClass: Array,
    name: String,
  },
}
